import XIcon from '@/shared-components/icons/components/public/XIcon';

import './styles/SearchField.css';

export default function SearchField({
  className = '',
  clearLabel = 'Clear search',
  leading,
  onClear,
  surface = 'secondary',
  value,
  ...inputProps
}) {
  const hasValue = typeof value === 'string' && value.length > 0;
  const canClear = typeof onClear === 'function' && hasValue;
  const surfaceClassName = surface === 'background'
    ? 'search-field--background'
    : 'search-field--secondary';

  return (
    <div className={`search-field ${surfaceClassName} ${className}`.trim()}>
      {leading && <span className="search-field__leading">{leading}</span>}

      <input
        {...inputProps}
        className="search-field__input"
        type="search"
        value={value}
      />

      {canClear && (
        <button
          type="button"
          className="search-field__clear"
          onClick={onClear}
          aria-label={clearLabel}
        >
          <XIcon />
        </button>
      )}
    </div>
  );
}
